import type { ImageNativeProps, ImageProps, Source, Breakpoints } from './types';

type GetSource = {
    [key in Breakpoints]?: Source;
} & { src: ImageNativeProps['src'] };

export const getKey = () => Math.random() * 1000;
export const generateSrcSet = (srcSet: Source['srcSet']): string | undefined => {
    if (typeof srcSet === 'object') {
        return `${srcSet.regular} 1x, ${srcSet.retina ? `${srcSet.retina} 2x` : ''} `;
    }

    return srcSet;
};
export const getSource = (imageSrc: ImageProps['src']): GetSource => {
    if (typeof imageSrc === 'object') {
        const { default: src, ...sources } = imageSrc;

        return { src, ...sources };
    }

    return { src: imageSrc };
};
